import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChangeModelStatusPayload, ModelsState } from "./types";

export const initialState: ModelsState = {
  loading: false,
  loadError: null,
  items: null,
};

const modelsSlice = createSlice({
  name: "models",
  initialState,
  reducers: {
    fetchModels: (state) => {
      state.loading = true;
      state.loadError = null;
    },
    fetchModelsSuccess: (state, action) => {
      state.loading = false;
      state.loadError = null;
      state.items = action.payload;
    },
    fetchModelsFailure: (state, action: PayloadAction<string | undefined>) => {
      state.loading = false;
      state.loadError = action.payload ?? null;
    },

    changeModelStatusSuccess: (state) => {
      state.loading = false;
    },
    changeModelStatusFailure: (state) => {
      state.loading = false;
    },
  },
});

export const changeModelStatus = createAction<ChangeModelStatusPayload>("models/changeModelStatus");

export const {
  fetchModels,
  fetchModelsSuccess,
  fetchModelsFailure,
  changeModelStatusSuccess,
  changeModelStatusFailure,
} = modelsSlice.actions;

export default modelsSlice.reducer;